module.exports = "/_next/static/images/gradientBG3-dfb16e99f5277b9bce578f5b8c667ca4.png";